import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';

const BannerContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[4]};
  background-color: ${({ theme }) => theme.green[500]};
  color: #ffffff;
  min-height: 44px;
  position: relative;
  flex-shrink: 0;

  @media (max-width: 767px) {
    padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]};
    gap: ${({ theme }) => theme.spacing[1]};
    flex-wrap: wrap;
  }
`;

const BannerText = styled(Typography)`
  && {
    font-size: 0.85rem;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    line-height: 1.4;

    @media (max-width: 767px) {
      font-size: 0.78rem;
    }
  }
`;

const CloseButton = styled(IconButton)`
  && {
    color: #ffffff;
    padding: 4px;
    position: absolute;
    right: ${({ theme }) => theme.spacing[2]};

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
`;

/**
 * Persistent demo mode banner displayed at the top of the dashboard.
 * Shown only when the user is logged in with the demo account.
 * Dismissible for the current session via a close button.
 */
export const DemoBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  if (dismissed) return null;

  const handleSignUp = () => {
    navigate('/signup');
  };

  return (
    <BannerContainer role="banner" aria-label="Demo mode notice">
      <BannerText variant="body2">
        You&apos;re exploring a demo account. Create your own account to start tracking your fitness journey.
      </BannerText>
      <Button
        variant="outlined"
        size="small"
        onClick={handleSignUp}
        sx={{
          color: '#ffffff',
          borderColor: 'rgba(255, 255, 255, 0.6)',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.78rem',
          borderRadius: '16px',
          px: 2,
          py: 0.25,
          whiteSpace: 'nowrap',
          flexShrink: 0,
          '&:hover': {
            borderColor: '#ffffff',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          },
        }}
      >
        Sign Up
      </Button>
      <CloseButton
        size="small"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss demo banner"
      >
        <CloseIcon fontSize="small" />
      </CloseButton>
    </BannerContainer>
  );
};

export default DemoBanner;
